import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import Alert from '@mui/material/Alert'
import Paper from '@mui/material/Paper'
import Divider from '@mui/material/Divider'
import { useRatingsStore } from '../../stores/ratingsStore'
import RatingForm from '../RatingForm'

export interface RatingPromptProps {
  diveId: string
  currentUserId: string
}

const RatingPrompt = ({ diveId, currentUserId }: RatingPromptProps) => {
  const { pendingRatings, loadPendingRatings } = useRatingsStore()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      setLoading(true)
      await loadPendingRatings(diveId)
      if (!cancelled) {
        setLoading(false)
      }
    }

    load()

    return () => {
      cancelled = true
    }
  }, [diveId, loadPendingRatings])

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    )
  }

  const pendingRatees = pendingRatings[diveId] ?? []

  if (pendingRatees.length === 0) {
    return (
      <Alert severity='success' sx={{ mt: 2 }}>
        All ratings submitted
      </Alert>
    )
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant='h6' gutterBottom>
        Rate your dive companions
      </Typography>

      {pendingRatees.map((ratee, index) => (
        <Paper key={ratee.id} sx={{ p: 2, mb: 2 }} variant='outlined'>
          <Typography variant='subtitle1' sx={{ mb: 1 }}>
            Rate: {ratee.displayName}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <RatingForm diveId={diveId} rateeId={ratee.id} />
        </Paper>
      ))}
    </Box>
  )
}

export default RatingPrompt
